import { HttpHeaders } from "@angular/common/http";
import { DynamicField } from "./dynamic-field.model";

export class DynamicFileLoader<T> extends DynamicField<T> {

    url?: string;
    maxFileSize?: number;
    method?: 'post' | 'put';
    multiple?: boolean;
    invalidFileSizeMessageSummary?: string;
    invalidFileSizeMessageDetail?: string;
    invalidFileTypeMessageSummary?: string;
    showUploadButton?: boolean;
    showCancelButton?: boolean;
    mode?: 'basic' | 'advanced';
    headers?: HttpHeaders;
    fileLimit?: number;
    files?: File[];
    auto?: boolean;
    accept?: string;


    constructor(source: Partial<DynamicFileLoader<T>>) {
        super();
        Object.assign(this, source);

    }
}